import { defineMessages } from '../../i18n/messages';

export const HowItWorksMessages = defineMessages({
  TITLE: {
    id: 'homepage.how_it_works.title',
    text: 'How It Works',
    description: 'Section heading for the step-by-step explanation of the Localingos workflow on the homepage.',
  },
  SUBTITLE: {
    id: 'homepage.how_it_works.subtitle',
    text: 'Install the CLI, let agentic AI handle the integration, then sync. Go grab a coffee. Localization is done before you get back.',
    description: 'Subtitle below the "How It Works" heading. Uses a casual, humorous tone to emphasize speed. "Agentic AI" refers to AI coding assistants that autonomously perform tasks. "CLI" is Command Line Interface.',
  },
  STEP1_TITLE: {
    id: 'homepage.how_it_works.step1_title',
    text: 'Sign Up & Create a Project',
    description: 'Title for step 1 in the three-step workflow. The "&" connects two actions: creating an account and setting up a project.',
  },
  STEP1_DESCRIPTION: {
    id: 'homepage.how_it_works.step1_description',
    text: 'Create a free account, set up a project with your target languages, and generate an API key. Takes under a minute with no credit card required.',
    description: 'Description for step 1. Explains the initial setup process: account creation, project configuration, and API key generation. Emphasizes it is fast and free.',
  },
  STEP1_DETAILS: {
    id: 'homepage.how_it_works.step1_details',
    text: 'Free account includes 5,000 words and access to all features',
    description: 'Additional detail shown below step 1. Clarifies what the free tier includes.',
  },
  STEP2_TITLE: {
    id: 'homepage.how_it_works.step2_title',
    text: 'Install CLI & Let AI Integrate',
    description: 'Title for step 2. "CLI" is Command Line Interface. "AI" refers to agentic AI coding assistants that perform the integration automatically.',
  },
  STEP2_DESCRIPTION: {
    id: 'homepage.how_it_works.step2_description',
    text: 'Install the Localingos CLI and run the setup. It detects your tech stack and generates a prompt for your AI agent (Cursor, Copilot, etc.) that handles the entire i18n migration: framework setup, string extraction, and locale wiring, all automatically.',
    description: 'Description for step 2. Explains that the CLI analyzes the project and creates instructions for AI coding assistants to perform the full internationalization setup. "i18n" is the abbreviation for internationalization. "Cursor" and "Copilot" are AI coding tools. "Locale wiring" means connecting translation files to the application.',
  },
  STEP2_DETAILS: {
    id: 'homepage.how_it_works.step2_details',
    text: 'Zero manual integration. Agentic AI does the heavy lifting in minutes.',
    description: 'Additional detail for step 2. Emphasizes that developers do not need to manually set up internationalization.',
  },
  STEP3_TITLE: {
    id: 'homepage.how_it_works.step3_title',
    text: 'Sync & Ship',
    description: 'Title for step 3. "Sync" means synchronizing translation files. "Ship" means deploying/releasing the application. Short and punchy.',
  },
  STEP3_DESCRIPTION: {
    id: 'homepage.how_it_works.step3_description',
    text: 'Run localingos sync to push your source strings. Translations happen automatically in seconds. Run sync again to pull them down into your locale files. Done, you are localized.',
    description: 'Description for step 3. Explains the sync workflow: push source strings, wait for automatic translation, pull translated files. "localingos sync" is a CLI command and should not be translated. "Locale files" are translation files for different languages.',
  },
  STEP3_DETAILS: {
    id: 'homepage.how_it_works.step3_details',
    text: 'Continuous localization: repeat on every release with near-zero effort.',
    description: 'Additional detail for step 3. Explains that this process can be repeated for every software release with minimal work.',
  },
});
